<template>
  <v-overlay :value="loading" z-index="9999">
    <div class="text-center">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"/>
      <div class="mt-4">
        <h3 class="white--text">
          Yükleniyor...
        </h3>
      </div>
    </div>
  </v-overlay>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GlobalLoading',
  computed: { ...mapGetters('ui', ['loading']) },
};
</script>
